
import EE from '../helpers/ee'


function openModal(id) {
  const modal = document.querySelectorAll('[data-video-modal="'+id+'"]')[0]
  modal.classList.add('video-modal--open')
  EE.emit('no-scroll-on')
}

function closeModals() {
  const modals = document.querySelectorAll('[data-video-modal]')
  for (let i = 0; i < modals.length; i++) {
    let modal = modals[i]
    modal.querySelectorAll('.video-modal-inner')[0].innerHTML = '';
    modal.classList.remove('video-modal--open')
  }
  EE.emit('no-scroll-off')
}

function modalIsOpen(modal) {
  return modal.classList.contains('video-modal--open')
}


function shouldCloseModal(allModals) {
  for (let i = 0; i < allModals.length; i++) {
    let modal = allModals[i];
    if (modalIsOpen(modal)) {
      closeModals(modal)
    }
  }
}


function initVideo(modal, id) {
  const iframe = document.createElement("iframe");
  const autoplay = '?autoplay=1'
  const related_no = '&rel=0'
  const src = '//www.youtube.com/embed/' + id + autoplay + related_no
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "0";
  iframe.setAttribute('src', src);
  modal.querySelectorAll('.video-modal-inner')[0].innerHTML = '';
  modal.querySelectorAll('.video-modal-inner')[0].appendChild(iframe);
  return false;
}

function addClickListeners(videoAnchor) {
  videoAnchor.addEventListener('click', function(e){
    let id = this.getAttribute('data-video-id');
    let modal = document.querySelectorAll('[data-video-modal="' + id + '"]')[0]
    e.preventDefault();
    openModal(id)
    initVideo(modal, id)
  })
}

(function(){
  const videoAnchors = document.querySelectorAll('.js-video-anchor')
  let videoAnchor
  for (let i = 0; i < videoAnchors.length; i++) {
    videoAnchor = videoAnchors[i]
    addClickListeners(videoAnchor)
  }

  document.addEventListener('click', function (e){
    if (
      !e.target.classList.contains('video-modal-inner') &&
      !e.target.classList.contains('js-video-anchor')
    ) {
      shouldCloseModal(document.querySelectorAll('[data-video-modal]'));
    }
  })
})();


// WEBPACK FOOTER //
// ./assets/js/modal/modal.js